import { memo } from "react";

import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { InterpolateFilledIcon, InterpolateIcon } from "../../../../misc/icons";

type InterpolatedMetricAdornmentProps = {
  isInterpolatedValue?: boolean;
};

const InterpolatedMetricAdornment = ({ isInterpolatedValue }: InterpolatedMetricAdornmentProps) => {
  const { t } = useTranslation("common");
  let titleAccess = t("interpolation_enabled");
  if (isInterpolatedValue) {
    titleAccess = t("interpolated_value");
  }

  return (
    <Tooltip placement="top" arrow title={titleAccess}>
      <Box display="flex">
        {isInterpolatedValue && <InterpolateIcon sx={{ ml: -1, mr: 0.5 }} color="disabled" />}
        {!isInterpolatedValue && <InterpolateFilledIcon sx={{ ml: -1, mr: 0.5 }} color="disabled" />}
      </Box>
    </Tooltip>
  );
};

export default memo(InterpolatedMetricAdornment);
